import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Hero from "./_components/hero";
import RegisterOtpCard from "./_components/register-otp-card";

export default function RegistrationOtp() {
  return (
    <WebLayout>
      <Hero />
      <RegisterOtpCard />
      <Footer />
    </WebLayout>
  );
}
